import {LoadingState} from "@material-dev/insights-portal-ui-components/lib/types";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {
    CreateExcludedVariableCommand,
    DeleteExcludedVariableCommand,
    ExcludedVariablesClient,
    IExcludedVariablesClient,
} from "app/ApiClient";
import { checkAndThrowInstructionValidationException } from "types";
import {initialExcludedVariablesState} from "./excludedVariablesState";

const excludedVariableClient: IExcludedVariablesClient = new ExcludedVariablesClient(process.env.REACT_APP_API_URL);

export const excludeVariable = createAsyncThunk(
    "excludedVariables/excludeVariable",
    async (request: CreateExcludedVariableCommand, {rejectWithValue}) => {
        try {

            const result = await excludedVariableClient.create(request);
            checkAndThrowInstructionValidationException(result);
            return result
        } catch (error) {
            return rejectWithValue(error);
        }
    },
);
export const includeVariable = createAsyncThunk(
    "excludedVariables/includeVariable",
    async (
        request: DeleteExcludedVariableCommand,
        {rejectWithValue},
    ) => {
        try {

            const result = await excludedVariableClient.delete(request);
            checkAndThrowInstructionValidationException(result);
            return result
        } catch (error) {
            return rejectWithValue(error);
        }
    },
);

const exludedVariablesSlice = createSlice({
    name: "excludedVariables",
    initialState: initialExcludedVariablesState,
    reducers: {
        resetExcludedVariable: (state) => {
            state.loading = LoadingState.idle;
        },
    },
    extraReducers: (builder) => {
        // excludeVariable
        builder.addCase(excludeVariable.pending, (state) => {
            state.loading = LoadingState.pending;
        });
        builder.addCase(excludeVariable.rejected, (state) => {
            state.loading = LoadingState.failed;
        });
        builder.addCase(excludeVariable.fulfilled, (state) => {
            state.loading = LoadingState.succeed;
        });

        // includeVariable
        builder.addCase(includeVariable.pending, (state) => {
            state.loading = LoadingState.pending;
        });
        builder.addCase(includeVariable.rejected, (state) => {
            state.loading = LoadingState.failed;
        });
        builder.addCase(includeVariable.fulfilled, (state) => {
            state.loading = LoadingState.succeed;
        });
    },
});
export const {resetExcludedVariable} = exludedVariablesSlice.actions;
export default exludedVariablesSlice.reducer;
